module.exports = __webpack_public_path__ + "static/media/francoise-noir.706b9538.png";